import {
  CreateKeywordAndAddToPaperRequest,
  CreateKeywordAndAddToRepositoryAndPaperRequest,
  CreateKeywordAndAddToRepositoryAndPaperResponse,
  DeleteKeywordFromPaperRequest,
  GetKeywordsForRepositoryRequest,
} from "../types/Keyword";
import {
  CreatePaperAndAddToRepositoryRequest,
  CreatePaperAndAddToRepositoryResponse,
  GetKeywordsForPaperRequest,
  ListPapersInRespositoryRequest,
} from "../types/Paper";
import {
  CreateParameterAndAddToRepositoryAndPaperRequest,
  CreateParameterAndAddToRepositoryAndPaperResponse,
  DeleteParameterFromPaperRequest,
  GetParametersForPaperRequest,
  GetParametersForRepositoryRequest,
} from "../types/Parameter";
import {
  CreateRepositoryRequest,
  GetRepositoryRequest,
  ListRepositoriesRequest,
} from "../types/repository";
import { userDataType } from "../types/user";
import { signupResponseType } from "../types/user";
import { formatPaperFromResponse } from "../utils/Paper/FormatPaperFromResponse";

let baseURL: string;
if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  // baseURL = "http://localhost:8080";
  baseURL = "https://pckxmft7ld.execute-api.us-west-1.amazonaws.com/Prod";
} else {
  baseURL = "https://api.basedid.com";
}
const signupURL = baseURL + "/signup";
const loginURL = baseURL + "/login";
const createRepositoryURL = baseURL + "/repositories";
const getRepositoryURL = (repositoryId: string) =>
  `${baseURL}/repositories/${repositoryId}`;
const listRepositoriesURL = baseURL + "/repositories";
const listPapersInRepositoryURL = baseURL + "/papers-in-repository";
const createPaperAndAddToRepositoryRequestURL =
  baseURL + "/create-paper-and-add-to-repository";

const getKeywordsBaseURL = (paperId: string) =>
  `${baseURL}/papers/${paperId}/keywords`;
const getRepositoryPaperKeywordsBaseURL = (
  repositoryId: string,
  paperId: string
) => `${baseURL}/repositories/${repositoryId}/papers/${paperId}/keywords`;
const getRepositoryPaperParametersBaseURL = (
  repositoryId: string,
  paperId: string
) => `${baseURL}/repositories/${repositoryId}/papers/${paperId}/parameters`;
const getRepositoryKeywordsBaseURL = (repositoryId: string) =>
  `${baseURL}/repositories/${repositoryId}/keywords`;
const getRepositoryParametersBaseURL = (repositoryId: string) =>
  `${baseURL}/repositories/${repositoryId}/parameters`;

export async function signup(
  userData: userDataType
): Promise<signupResponseType> {
  const response = await fetch(`${signupURL}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userData),
  });
  const data = await response.json();
  if (data.error) {
    throw new Error(data.error ? data.error : "Could not sign up user.");
  }

  return data;
}

export async function login(userData: userDataType) {
  const response = await fetch(`${loginURL}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userData),
  });
  const data = await response.json();
  console.log(data);
  if (data.error) {
    throw new Error(data.error ? data.error : "Could not login user.");
  }

  return data;
}

export async function createRepository(
  createRepositoryRequest: CreateRepositoryRequest
) {
  const createRepositoryRequestBody = {
    name: createRepositoryRequest.name,
  };
  const response = await fetch(`${createRepositoryURL}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${createRepositoryRequest.token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(createRepositoryRequestBody),
  });
  const data = await response.json();
  if (data.error) {
    throw new Error(data.error ? data.error : "Could not create repository.");
  }

  return data;
}

export async function getRepository(
  getRepositoryRequest: GetRepositoryRequest
) {
  const response = await fetch(`${getRepositoryURL(getRepositoryRequest.id)}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${getRepositoryRequest.token}`,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (data.error) {
    throw new Error(data.error ? data.error : "Could not fetch repository.");
  }

  return data;
}

export async function listRepositories(
  listRepositoriesRequest: ListRepositoriesRequest
) {
  const response = await fetch(`${listRepositoriesURL}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${listRepositoriesRequest.token}`,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (data.error) {
    throw new Error(data.error ? data.error : "Could not create repository.");
  }

  return data;
}

export async function listPapersInRepository(
  listPapersInRepositoryRequest: ListPapersInRespositoryRequest
) {
  const queryParams = new URLSearchParams({
    repository_id: listPapersInRepositoryRequest.repository_id,
  }).toString();

  const response = await fetch(`${listPapersInRepositoryURL}?${queryParams}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${listPapersInRepositoryRequest.token}`,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  if (data.error) {
    throw new Error(data.error ? data.error : "Could not create repository.");
  }

  return formatPaperFromResponse(data);
}

export async function createPaperAndAddToRepository(
  createPaperAndAddToRepositoryRequest: CreatePaperAndAddToRepositoryRequest
): Promise<CreatePaperAndAddToRepositoryResponse> {
  // Convert repository_id to a number if it's not already
  const repositoryId = Number(
    createPaperAndAddToRepositoryRequest.repository_id
  );
  if (isNaN(repositoryId)) {
    throw new Error("Invalid repository ID");
  }

  const createRepositoryRequestBody = {
    repository_id: repositoryId,
    name: createPaperAndAddToRepositoryRequest.name,
  };
  const response = await fetch(`${createPaperAndAddToRepositoryRequestURL}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${createPaperAndAddToRepositoryRequest.token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(createRepositoryRequestBody),
  });
  const data = await response.json();
  if (data.error) {
    throw new Error(
      data.error ? data.error : "Could not create add paper to repository."
    );
  }

  return data;
}

export async function getKeywordsForPaper(
  getKeywordsForPaperRequest: GetKeywordsForPaperRequest
) {
  const response = await fetch(
    `${getKeywordsBaseURL(getKeywordsForPaperRequest.paper_id)}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getKeywordsForPaperRequest.token}`,
        "Content-Type": "application/json",
      },
    }
  );
  const data = await response.json();
  if (data.error) {
    throw new Error(data.error ? data.error : "Could not create repository.");
  }

  return data;
}

export async function createKeywordAndAddToPaper(
  createKeywordAndAddToPaperRequest: CreateKeywordAndAddToPaperRequest
) {
  const createKeywordAndAddToPaperRequestBody = {
    keyword: createKeywordAndAddToPaperRequest.keyword,
  };
  const response = await fetch(
    `${getKeywordsBaseURL(createKeywordAndAddToPaperRequest.paper_id)}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${createKeywordAndAddToPaperRequest.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(createKeywordAndAddToPaperRequestBody),
    }
  );
  const data = await response.json();
  if (data.error) {
    throw new Error(
      data.error ? data.error : "Could not create add paper to repository."
    );
  }

  return data;
}

export async function createKeywordAndAddToRepositoryAndPaper(
  createKeywordAndAddToRepositoryAndPaperRequest: CreateKeywordAndAddToRepositoryAndPaperRequest
): Promise<CreateKeywordAndAddToRepositoryAndPaperResponse> {
  const createKeywordAndAddToPaperRequestBody = {
    keyword: createKeywordAndAddToRepositoryAndPaperRequest.keyword,
  };
  const response = await fetch(
    `${getRepositoryPaperKeywordsBaseURL(createKeywordAndAddToRepositoryAndPaperRequest.repository_id, createKeywordAndAddToRepositoryAndPaperRequest.paper_id)}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${createKeywordAndAddToRepositoryAndPaperRequest.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(createKeywordAndAddToPaperRequestBody),
    }
  );
  const data = await response.json();
  if (data.error) {
    throw new Error(
      data.error ? data.error : "Could not create add keyword to paper."
    );
  }

  return data;
}

export async function deleteKeywordFromPaper(
  deleteKeywordFromPaperRequest: DeleteKeywordFromPaperRequest
) {
  const { repository_id, paper_id, keyword_id, token } =
    deleteKeywordFromPaperRequest;
  const response = await fetch(
    `${getRepositoryPaperKeywordsBaseURL(repository_id, paper_id)}/${keyword_id}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  const data = await response.json();
  if (!response.ok) {
    throw new Error(
      data.error ? data.error : "Could not delete the keyword from the paper."
    );
  }
  return data;
}

export async function getParametersForPaper(
  getParametersForPaperRequest: GetParametersForPaperRequest
) {
  const { repository_id, paper_id, token } = getParametersForPaperRequest;
  const response = await fetch(
    `${getRepositoryPaperParametersBaseURL(repository_id, paper_id)}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        // Include cache control headers to prevent caching
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
      },
    }
  );
  const data = await response.json();
  if (data.error) {
    throw new Error(
      data.error ? data.error : "Could not fetch parameters for paper."
    );
  }

  return data;
}

export async function createParameterAndAddToRepositoryAndPaper(
  createKeywordAndAddToRepositoryAndPaperRequest: CreateParameterAndAddToRepositoryAndPaperRequest
): Promise<CreateParameterAndAddToRepositoryAndPaperResponse> {
  const { repository_id, paper_id, token } =
    createKeywordAndAddToRepositoryAndPaperRequest;
  const createParameterAndAddToPaperRequestBody = {
    key: createKeywordAndAddToRepositoryAndPaperRequest.key,
    value: createKeywordAndAddToRepositoryAndPaperRequest.value,
    unit: createKeywordAndAddToRepositoryAndPaperRequest.unit,
  };
  const response = await fetch(
    `${getRepositoryPaperParametersBaseURL(repository_id, paper_id)}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(createParameterAndAddToPaperRequestBody),
    }
  );
  const data = await response.json();
  if (data.error) {
    throw new Error(
      data.error ? data.error : "Could not add parameter to paper."
    );
  }

  return data;
}

export async function deleteParameterFromPaper(
  deleteParameterFromPaperRequest: DeleteParameterFromPaperRequest
) {
  const { repository_id, paper_id, parameter_id, token } =
    deleteParameterFromPaperRequest;
  const response = await fetch(
    `${getRepositoryPaperParametersBaseURL(repository_id, paper_id)}/${parameter_id}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  const data = await response.json();
  if (!response.ok) {
    throw new Error(
      data.error ? data.error : "Could not delete the parameter from the paper."
    );
  }
  return data;
}

export async function getKeywordsFoRepository(
  getKeywordsForRepositoryRequest: GetKeywordsForRepositoryRequest
) {
  const response = await fetch(
    `${getRepositoryKeywordsBaseURL(getKeywordsForRepositoryRequest.repository_id)}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getKeywordsForRepositoryRequest.token}`,
        "Content-Type": "application/json",
      },
    }
  );
  const data = await response.json();
  if (data.error) {
    throw new Error(data.error ? data.error : "Could not create repository.");
  }

  return data;
}

export async function getParametersForRepository(
  getParametersForRepositoryRequest: GetParametersForRepositoryRequest
) {
  const response = await fetch(
    `${getRepositoryParametersBaseURL(getParametersForRepositoryRequest.repository_id)}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getParametersForRepositoryRequest.token}`,
        "Content-Type": "application/json",
      },
    }
  );
  const data = await response.json();
  if (data.error) {
    throw new Error(data.error ? data.error : "Could not create repository.");
  }

  return data;
}

export async function getPapersFromArxivBySearchPhrase(url: string) {
  const response = await fetch(url, {
    method: "GET",
  });
  if (!response.ok) {
    throw new Error("Could not fetch papers from Arxiv.");
  }
  const text = await response.text();
  return text;
}

export async function getKeyWordsAndParmetersFromOpenAi(
  paperSummary: string,
  apiKey: string = "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"
) {
  let apiKeyValue;
  if (apiKey === "") {
    apiKeyValue = process.env.REACT_APP_OPENAI_API_KEY;
  } else {
    apiKeyValue = apiKey;
  }

  const base_url = "https://api.openai.com/v1/chat/completions";
  const response = await fetch(base_url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${apiKeyValue}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      model: "gpt-3.5-turbo",
      messages: [
        { role: "system", content: "You are a helpful assistant." },
        {
          role: "user",
          content: `From the research paper summary provided, extract keywords as a list(max length 8) and also extract as numerical quantities from the summary. Format is -
{
"Keywords": [keywords_list of max length 8]
"Quantities": [[quantity_name, quantity_value, quantity_unit]]
}
For example for the summary - In this paper, we predict the likelihood of a player making a shot in basketball from multiagent trajectories. Previous approaches to similar problems center on hand-crafting features to capture domain specific knowledge. Although intuitive, recent work in deep learning has shown this approach is prone to missing important predictive features. To circumvent this issue, we present a convolutional neural network (CNN) approach where we initially represent the multiagent behavior as an image. To encode the adversarial nature of basketball, we use a multi-channel image which we then feed into a CNN. Additionally, to capture the temporal aspect of the trajectories we fade the player trajectories. We find that this approach is superior to a traditional FFN model. By using gradient ascent to create images using an already trained CNN, we discover what features the CNN filters learn. Last, we find that a combined CNN+FFN is the best performing network with an error rate of 39%.
Example output -
{
"Keywords":[ "basketball", "multiagent trajectories", "deep learning", "convolutional neural network (CNN)", "multi-channel image", "player trajectories", "gradient ascent", "FFN model"],
"Quantities":[["Error rate", 39, "percentage"]]
}
Summary for which i need output in the format specified above -
${paperSummary}`,
        },
      ],
      max_tokens: 200,
    }),
  });
  if (!response.ok) {
    throw new Error(
      "Request to openAi to extract keywords and parameters failed."
    );
  }
  const text = await response.text();
  return text;
}
